export const ObjectNames = {

    caseConstants: {
        Channel_Object: "Channel",
        Channel_Template: "Template",
        Pipeline_Object: "Pipeline",

        //custom
        caseFieldName: "Cases",
        Cases_Submodule_TypeName: 'Stages',
        levelName: 'Organization Level',
        caseCustomFieldName: 'CaseCustomFields',
        customFieldName: 'CustomField',

        // account
        AccountFieldName: "Account",
    },

    accountConstants: {
        Channel_Object: "Channel",
        Channel_Template: "Template",
        Pipeline_Object: "Pipeline",

        //custom
        caseFieldName: "Cases",
        Cases_Submodule_TypeName: 'Stages',
        levelName: 'Organization Level',
        AccountFieldName: "Account",
        accountCustomFieldName: "AccountCustomFields",
        customFieldName: 'CustomField',
    },

    opportunityConstants: {
        Channel_Object: "Channel",
        Channel_Template: "Template",
        Pipeline_Object: "Pipeline",

        //custom
        opportunityFieldName: "Opportunity",
        opportunityCustomFieldName: 'OpportunityCustomFields',
    },

    leadConstants: {
        Channel_Object: "Channel",
        Channel_Template: "Template",
        Pipeline_Object: "Pipeline",

        //custom
        leadFieldName: "Lead",
        leadCustomFieldName: 'LeadCustomFields',
    },

    BehaviorSubjectVariable: 'add',

    customConstants: {
        AddCustomTitle: 'Add Custom Field',
        EditCustomTitle: 'Edit Custom Field',
        // Section
        AddSectionTitle: 'Add New Section',
        EditSectionTitle: 'Edit Section',
        Inventory_Section_Object: "Product Section",
        Inventory_Section_TypeId: 96,
        Inventory_Section_TypeName: "Section",
        Purchase_Section_Object: "Purchase Section",
        Order_Section_Object: "Order Section",
    },

}

export enum Status {
    ACTIVE = 1,
    INACTIVE = 2
}

export enum Severity {
    Success = 'success',
    Error = 'error'
}

export enum FormControl {
    Dropdown = 1,
    MultiSelect = 11,
    Checkbox = 2,
    RadioButton = 3,
    Number = 19,
    Decimal = 20
}

export enum Answer {
    Yes = 'Yes',
    No = 'No'
}

export enum MenuItems {
    // Cases
    Channel = 'Channel',
    Stage = 'Stage',
    FieldData = 'Field Data',

    Add_Event_Stage = 'Stage',
    Add_Event_Channel = 'Channel',
    Add_Event_Field = 'Field',

    //Custom
    Add_Field = 'Add Custom Field',
    Add_Section = 'Add_Section'
}
export const Messages = {
    Name_Already_Exists: 'Name is already exist...',
    Channel_Already_Exists: 'Channel already exists...',
    Stage_Already_Exists: 'Stage already exists...',
    Channel_Added: 'Channel added successfully...',
    // Channel Create
    Channel_Created_Success: 'Channel created successfully...',
    Channel_Created_Error: 'Channel can not be created. Try again later...',
    // Channel Update
    Channel_Updated: 'Channel updated successfully...',
    Channel_Updated_Success: 'Channel updated successfully...',
    Channel_Updated_Error: 'Channel can not be updated. Try again later...',
    // Set Default Channel
    Set_Default_Channel_Success: 'is set as Default Channel ...',
    Set_Default_Channel_Error: 'Channel can not be set as dafault. Try again later...',
    // Channel Delete
    Channel_Deleted_Success: 'Channel deleted successfully...',
    Channel_Deleted_Error: 'Channel can not be deleted. Try again later...',
    // Stage Create
    Stage_Created_Success: 'Stage created successfully...',
    Stage_Created_Error: 'Stage can not be created. Try again later...',
    // Stage Update
    Stage_Updated_Success: 'Stage updated successfully...',
    Stage_Updated_Error: 'Stage can not be updated. Try again later...',
    // Stage Delete
    Stage_Deleted_Success: 'Stage deleted successfully...',
    Stage_Deleted_Error: 'Stage can not be deleted. Try again later...',
    // Template Update
    Template_Updated_Success: 'Template updated successfully...',
    Template_Updated_Error: 'Template can not be updated. Try again later...',
}

export const DefaultJSON = {
    Case_Channel_Section_Template: {
        id: 1,
        name: "Case Information",
        fields: [
            {
                id: 1,
                labelname: "Case No",
                name: "Case No",
                code: "caseNo",
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                width: "6",
                movable: false,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 1,
                formControl: "dropdownlist",
                PickListValues: null,
                field: "ticketNo",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 2,
                labelname: "Case Association",
                name: "Case Association",
                code: "caseAssociation",
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                width: "6",
                movable: false,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 1,
                formControl: "dropdownlist",
                PickListValues: null,
                field: "caseAssociationName",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 3,
                labelname: "Association Name",
                name: "Association Name",
                code: "associationName",
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                width: "6",
                movable: false,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "inputbox",
                PickListValues: null,
                field: "associationName",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 4,
                labelname: "Contact Name",
                name: "Contact Name",
                code: "contactName",
                isrequired: false,
                ischecked: true,
                isShowInSetting: true,
                width: "6",
                movable: true,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "inputbox",
                PickListValues: null,
                field: "contactName",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 5,
                labelname: "Contact Email Address",
                name: "Contact Email Address",
                code: "contactEmailAddress",
                isrequired: false,
                ischecked: true,
                isShowInSetting: true,
                width: "6",
                movable: true,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "inputbox",
                PickListValues: null,
                field: "contactEmailAddress",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 6,
                labelname: "Contact Phone Number",
                name: "Contact Phone Number",
                code: "contactPhoneNumber",
                isrequired: false,
                ischecked: true,
                isShowInSetting: true,
                width: "6",
                movable: true,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "inputbox",
                PickListValues: null,
                field: "contactMobileNo",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 7,
                labelname: "Source",
                name: "Source",
                code: "source",
                isrequired: false,
                ischecked: true,
                isShowInSetting: true,
                width: "6",
                movable: true,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 1,
                formControl: "dropdownlist",
                PickListValues: null,
                field: "sourceName",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 8,
                labelname: "Category",
                name: "Category",
                code: "category",
                isrequired: false,
                ischecked: true,
                isShowInSetting: true,
                width: "6",
                movable: true,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 1,
                formControl: "dropdownlist",
                PickListValues: null,
                field: "categoryName",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 9,
                labelname: "Sub - Category",
                name: "Sub - Category",
                code: "subCategory",
                isrequired: false,
                ischecked: true,
                isShowInSetting: true,
                width: "6",
                movable: true,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 1,
                formControl: "dropdownlist",
                PickListValues: null,
                field: "subCategoryName",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 10,
                labelname: "Priority",
                name: "Priority",
                code: "priority",
                isrequired: false,
                ischecked: true,
                isShowInSetting: true,
                width: "6",
                movable: true,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 1,
                formControl: "dropdownlist",
                PickListValues: null,
                field: "priorityName",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 11,
                labelname: "Subject",
                name: "Subject",
                code: "subject",
                isrequired: false,
                ischecked: true,
                isShowInSetting: true,
                width: "6",
                movable: true,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 1,
                formControl: "inputbox",
                PickListValues: null,
                field: "subject",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 12,
                labelname: "Reported By",
                name: "Reported By",
                code: "reportedBy",
                isrequired: false,
                ischecked: true,
                isShowInSetting: true,
                width: "6",
                movable: true,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "inputbox",
                PickListValues: null,
                field: "reportedBy",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 13,
                labelname: "Shared Files (Max Size 2MB)",
                name: "Shared Files (Max Size 2MB)",
                code: "sharedFiles",
                isrequired: false,
                ischecked: true,
                isShowInSetting: true,
                width: "6",
                movable: true,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 6,
                formControl: "FileUpload",
                PickListValues: null,
                field: "attachmentLinks",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 14,
                labelname: "Case Details",
                name: "Case Details",
                code: "caseDetails",
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                width: "12",
                movable: false,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "inputbox",
                PickListValues: null,
                field: "ticketDesc",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 15,
                labelname: "Stage",
                name: "Stage",
                code: "stage",
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                width: "12",
                movable: false,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "inputbox",
                PickListValues: null,
                field: "stageName",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 16,
                labelname: "Resolution Date",
                name: "Resolution Date",
                code: "resolutionDate",
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                width: "12",
                movable: false,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "inputbox",
                PickListValues: null,
                field: "resolutionDate",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 17,
                labelname: "Resolution Comment",
                name: "Resolution Comment",
                code: "resolutionComment",
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                width: "12",
                movable: false,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "inputbox",
                PickListValues: null,
                field: "resolutionComment",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 18,
                labelname: "Assigned Group",
                name: "Assigned Group",
                code: "assignedGroup",
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                width: "12",
                movable: false,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "dropdownlist",
                PickListValues: null,
                field: "assignedGroup",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 19,
                labelname: "Assigned User",
                name: "Assigned User",
                code: "assignedUser",
                isrequired: false,
                ischecked: true,
                isShowInSetting: true,
                width: "12",
                movable: false,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "dropdownlist",
                PickListValues: null,
                field: "assignedUser",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 20,
                labelname: "Created By",
                name: "Created By",
                code: "createdBy",
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                width: "12",
                movable: false,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "inputbox",
                PickListValues: null,
                field: "createdByName",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 21,
                labelname: "Created Date",
                name: "Created Date",
                code: "createdDate",
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                width: "12",
                movable: false,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "inputbox",
                PickListValues: null,
                field: "createdDate",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 22,
                labelname: "Last Updated By",
                name: "Last Updated By",
                code: "lastUpdatedBy",
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                width: "12",
                movable: false,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "inputbox",
                PickListValues: null,
                field: "lastUpdatedByName",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
            {
                id: 23,
                labelname: "Last Updated Date",
                name: "Last Updated Date",
                code: "lastUpdatedDate",
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                width: "12",
                movable: false,
                showForDrag: true,
                templateId: 1,
                sectionId: 1,
                custom: false,
                formControlId: 8,
                formControl: "inputbox",
                PickListValues: null,
                field: "updatedDate",
                mapObject: null,
                isColumnSetting: true,
                value: null,
                displayOrder: 0,
                fieldTypes: null,
            },
        ],
        systemGenerated: true,
        isDisplay: true,
        displayOrder: 0,
    },

    Opportunity_Channel_Section_Template: {
        id: 1,
        name: "Label Info",
        systemGenerated: true,
        fields:[
            {
              id: 1,
              labelname: "Opportunity Name ",
              name: "Opportunity Name",
              code: "oppname",
              isrequired: true,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: false,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 1,
              formControl: "dropdownlist",
              PickListValues: null,
              field: "name",
              mapObject: "opportunity",
              isColumnSetting: true,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 2,
              labelname: "Account Name",
              name: "Account Name",
              code: "account name",
              isrequired: true,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: false,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 8,
              formControl: "inputbox",
              PickListValues: null,
              field: "accountName",
              mapObject: "account",
              isColumnSetting: true,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 3,
              labelname: "Owner",
              name: "Owner",
              code: "owner",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 8,
              formControl: "inputbox",
              PickListValues: null,
              field: "owner",
              mapObject: "opportunityPipelines",
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 4,
              labelname: "Contact Name",
              name: "Contact Name",
              code: "contactname",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 8,
              formControl: "inputbox",
              PickListValues: null,
              field: "contactname",
              mapObject: "contactname",
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 5,
              labelname: "Contact Email",
              name: "Contact Email",
              code: "contactemail",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 8,
              formControl: "inputbox",
              PickListValues: null,
              field: "contactemail",
              mapObject: "contactemail",
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 6,
              labelname: "Contact Phone",
              name: "Contact Phone",
              code: "contactphone",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 8,
              formControl: "inputbox",
              PickListValues: null,
              field: "contactphone",
              mapObject: "contactphone",
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 7,
              labelname: "Quality",
              name: "Quality",
              code: "quality",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 8,
              formControl: "inputbox",
              PickListValues: null,
              field: "quality",
              mapObject: "quality",
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 8,
              labelname: "Source",
              name: "Source",
              code: "source",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 8,
              formControl: "inputbox",
              PickListValues: null,
              field: "sourceName",
              mapObject: "source",
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 9,
              labelname: "Close Date",
              name: "Close Date",
              code: "date",
              isrequired: true,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 8,
              formControl: "inputbox",
              PickListValues: null,
              field: "expectedDate",
              mapObject: "opportunity",
              isColumnSetting: true,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 10,
              labelname: "Stage",
              name: "Stage",
              code: "stage",
              isrequired: true,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 1,
              formControl: "dropdownlist",
              PickListValues: null,
              field: "stageName",
              mapObject: "opportunityStages",
              isColumnSetting: true,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 11,
              labelname: "Rep Confidence",
              name: "Rep Confidence",
              code: "repconfidence",
              isrequired: true,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 1,
              formControl: "dropdownlist",
              PickListValues: null,
              field: "repconfidence",
              mapObject: "repconfidence",
              isColumnSetting: true,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 12,
              labelname: "Total Amount",
              name: "Total Amount",
              code: "amount",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 1,
              formControl: "dropdownlist",
              PickListValues: null,
              field: "totalAmount",
              mapObject: "opportunity",
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 13,
              labelname: "Product Name",
              name: "Product or Services",
              code: "service",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 1,
              formControl: "dropdownlist",
              PickListValues: null,
              field: "productName",
              mapObject: "opportunityProduct",
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 28,
              labelname: "Product Description",
              name: "Product Description",
              code: "service",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 1,
              formControl: "dropdownlist",
              PickListValues: null,
              field: "productDescription",
              mapObject: "opportunityProduct",
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 15,
              labelname: "Unit",
              name: "Unit",
              code: "unit",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 1,
              formControl: "dropdownlist",
              PickListValues: null,
              field: "unit",
              mapObject: "opportunityProduct",
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 16,
              labelname: "UOM",
              name: "UOM",
              code: "uom",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 1,
              formControl: "dropdownlist",
              PickListValues: null,
              field: "uom",
              mapObject: "uom",
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 17,
              labelname: "Price",
              name: "Price",
              code: "price",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 8,
              formControl: "inputbox",
              PickListValues: null,
              field: "price",
              mapObject: "opportunityProduct",
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 18,
              labelname: "Item Total",
              name: "Item Total",
              code: "itemtotal",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "2",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 8,
              formControl: "inputbox",
              PickListValues: null,
              field: "caseDetails",
              mapObject: "opportunity",
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 19,
              labelname: "Opportunity Details",
              name: "Opportunity Details",
              code: "0pportunitydetails",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "12",
              movable: true,
              showForDrag: true,
              templateId: 1,
              sectionId: 1,
              custom: false,
              formControlId: 8,
              formControl: "inputbox",
              PickListValues: null,
              field: "description",
              mapObject: null,
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 20,
              labelname: "Probability",
              name: "Probability",
              code: "probability",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 2,
              sectionId: 1,
              custom: false,
              formControlId: 8,
              formControl: "InputBox",
              PickListValues: "[]",
              field: "probability",
              mapObject: null,
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            },
            {
              id: 21,
              labelname: "Forecast Category",
              name: "Forecast Category",
              code: "forecastCategory",
              isrequired: false,
              ischecked: true,
              isShowInSetting: true,
              isDuplicate: false,
              isGlobalSearch: false,
              width: "6",
              movable: true,
              showForDrag: true,
              templateId: 2,
              sectionId: 1,
              custom: false,
              formControlId: 8,
              formControl: "InputBox",
              PickListValues: "[]",
              field: "forcastCategory",
              mapObject: null,
              isColumnSetting: false,
              value: null,
              displayOrder: 0,
              isFieldSearchable: false,
              fieldDataType: null,
              Operators: null,
              fieldTypes: null,
              tooltip: ""
            }
          ],
        isDisplay: true,
    },

    Account_Channel_Section_Template: [
        {
            id: 3,
            name: "Contact Details",
            fields: [
                {
                    id: 1,
                    labelname: "Title",
                    name: "Title",
                    code: "title",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "12",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "title",
                    mapObject: "contact",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 2,
                    labelname: "First Name",
                    name: "First Name",
                    code: "first name",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: false,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "contactFirstName",
                    mapObject: "contact",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 3,
                    labelname: "Middle Initial",
                    name: "Middle Initial",
                    code: "count",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "contactMiddleName",
                    mapObject: "contact",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 4,
                    labelname: "Last Name",
                    name: "Last Name",
                    code: "last name",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "contactLastName",
                    mapObject: "contact",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 5,
                    labelname: "Email",
                    name: "Email",
                    code: "email",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: true,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "contactEmail",
                    mapObject: "contact",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                    fieldTypes: {
                        fields: [
                            {
                                id: 1,
                                labelname: "Work Email",
                                name: "Work Email",
                                code: "work",
                                isrequired: false,
                                ischecked: true,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactemailwork",
                                mapObject: "contactEmail",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                            {
                                id: 2,
                                labelname: "Home Email",
                                name: "Home Email",
                                code: "home",
                                isrequired: false,
                                ischecked: false,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactemailhome",
                                mapObject: "contactEmail",
                                isColumnSetting: false,
                                value: "",
                                displayOrder: 0,
                            },
                            {
                                id: 3,
                                labelname: "CE1",
                                name: "CE1",
                                code: "ce1",
                                isrequired: false,
                                ischecked: false,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactemailce1",
                                mapObject: "contactEmail",
                                isColumnSetting: false,
                                value: "",
                                displayOrder: 0,
                            },
                            {
                                id: 4,
                                labelname: "CE2",
                                name: "CE2",
                                code: "ce2",
                                isrequired: false,
                                ischecked: false,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactemailce2",
                                mapObject: "contactEmail",
                                isColumnSetting: false,
                                value: "",
                                displayOrder: 0,
                            },
                        ],
                        systemGenerated: true,
                        isDisplay: false,
                    },
                },
                {
                    id: 6,
                    labelname: "Phone",
                    name: "Phone",
                    code: "phone",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: true,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "phone",
                    mapObject: "contact",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                    fieldTypes: {
                        fields: [
                            {
                                id: 1,
                                labelname: "Mobile Phone",
                                name: "Mobile Phone",
                                code: "mobile",
                                isrequired: false,
                                ischecked: true,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactphonemobile",
                                mapObject: "contactPhone",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                            {
                                id: 2,
                                labelname: "Work Phone",
                                name: "Work Phone",
                                code: "work",
                                isrequired: false,
                                ischecked: false,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactphonework",
                                mapObject: "contactPhone",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                            {
                                id: 3,
                                labelname: "Home Phone",
                                name: "Home",
                                code: "home",
                                isrequired: false,
                                ischecked: false,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactphonehome",
                                mapObject: "contactPhone",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                            {
                                id: 4,
                                labelname: "CP1",
                                name: "CP1",
                                code: "cp1",
                                isrequired: false,
                                ischecked: false,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactphonecp1",
                                mapObject: "contactPhone",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                            {
                                id: 5,
                                labelname: "CP2",
                                name: "CP2",
                                code: "cp2",
                                isrequired: false,
                                ischecked: false,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactphonecp2",
                                mapObject: "contactPhone",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                        ],
                        systemGenerated: true,
                        isDisplay: false,
                    },
                },
                {
                    id: 7,
                    labelname: "Social Profile",
                    name: "Social Profile",
                    code: "social",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: true,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "social",
                    mapObject: "contact",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                    fieldTypes: {
                        fields: [
                            {
                                id: 1,
                                labelname: "Website",
                                name: "Website",
                                code: "website",
                                isrequired: false,
                                ischecked: true,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactsocialwebsite",
                                mapObject: "contactSocial",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                            {
                                id: 2,
                                labelname: "Twitter",
                                name: "Twitter",
                                code: "twitter",
                                isrequired: false,
                                ischecked: true,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactsocialtwitter",
                                mapObject: "contactSocial",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                            {
                                id: 3,
                                labelname: "Facebook",
                                name: "Facebook",
                                code: "facebook",
                                isrequired: false,
                                ischecked: true,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactsocialfacebook",
                                mapObject: "contactSocial",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                            {
                                id: 4,
                                labelname: "Linkedin",
                                name: "Linkedin",
                                code: "linkedin",
                                isrequired: false,
                                ischecked: false,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactsociallinkedin",
                                mapObject: "contactSocial",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                            {
                                id: 5,
                                labelname: "Instagram",
                                name: "Instagram",
                                code: "instagram",
                                isrequired: false,
                                ischecked: true,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "contactsocialinstagram",
                                mapObject: "contactSocial",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                        ],
                        systemGenerated: true,
                        isDisplay: false,
                    },
                },
                {
                    id: 8,
                    labelname: "Profile Image",
                    name: "Profile Image",
                    code: "image",
                    isrequired: false,
                    ischecked: false,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 6,
                    formControl: "FileUpload",
                    PickListValues: null,
                    field: "image",
                    mapObject: "contact",
                    isColumnSetting: false,
                    value: null,
                    displayOrder: 0,
                },
                {
                    id: 9,
                    labelname: "Job Function",
                    name: "Job Function",
                    code: "jobFunction",
                    isrequired: false,
                    ischecked: false,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "jobFunction",
                    mapObject: "contact",
                    isColumnSetting: false,
                    value: null,
                    displayOrder: 0,
                },
                {
                    id: 10,
                    labelname: "Contact Name",
                    name: "Contact Name",
                    code: "contact name",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: true,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "contactname",
                    mapObject: "contact",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
            ],
            systemGenerated: true,
            isDisplay: false,
            displayOrder: 0,
        },
        {
            id: 1,
            name: "Account Information",
            fields: [
                {
                    id: 1,
                    labelname: "Account Name",
                    name: "Account Name",
                    code: "account name",
                    isrequired: true,
                    ischecked: true,
                    isShowInSetting: true,
                    width: "6",
                    movable: false,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "businessName",
                    mapObject: "account",
                    isColumnSetting: true,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 2,
                    labelname: "Email Address",
                    name: "Email Address",
                    code: "emailAddress",
                    isrequired: false,
                    ischecked: false,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "emailAddress",
                    mapObject: "account",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 3,
                    labelname: "Parent Account",
                    name: "Parent Account",
                    code: "parent account",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: true,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "mainCustomer",
                    mapObject: "parentAccount",
                    isColumnSetting: true,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 4,
                    labelname: "Account Type(s)",
                    name: "Account Type(s)",
                    code: "account type",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: true,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "accountTypesName",
                    mapObject: "accountTypes",
                    isColumnSetting: true,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 5,
                    labelname: "Account Number",
                    name: "Account Number",
                    code: "account number",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: true,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "accountNumber",
                    mapObject: "account",
                    isColumnSetting: true,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 6,
                    labelname: "Timezone",
                    name: "Timezone",
                    code: "Timezone",
                    isrequired: false,
                    ischecked: false,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "timezoneName",
                    mapObject: "timezone",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 7,
                    labelname: "Currency",
                    name: "Currency",
                    code: "currency",
                    isrequired: false,
                    ischecked: false,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "currencyName",
                    mapObject: "currency",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
            ],
            systemGenerated: true,
            isDisplay: true,
            displayOrder: 1,
        },
        {
            id: 2,
            name: "Account Details",
            fields: [
                {
                    id: 1,
                    labelname: "Doing Business as (DBA)",
                    name: "Doing Business as (DBA)",
                    code: "dba",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "12",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "doingBusinessAs",
                    mapObject: "account",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 2,
                    labelname: "Tax ID (EIN)",
                    name: "Tax ID (EIN)",
                    code: "ein",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: false,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "taxId",
                    mapObject: "account",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 3,
                    labelname: "Number of Employees",
                    name: "Number of Employees",
                    code: "count",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "employeesRangeName",
                    mapObject: "employeesRange",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 4,
                    labelname: "Estimated Annual Revenue",
                    name: "Estimated Annual Revenue",
                    code: "revenue",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "annualRevenueName",
                    mapObject: "annualRevenue",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 5,
                    labelname: "Ownership Type",
                    name: "Ownership Type",
                    code: "ownership",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "ownershipName",
                    mapObject: "ownership",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 6,
                    labelname: "Account Category",
                    name: "Account Category",
                    code: "classification",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "classificatioName",
                    mapObject: "classification",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 7,
                    labelname: "Founded Year",
                    name: "Founded Year",
                    code: "founded year",
                    isrequired: false,
                    ischecked: false,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "foundedYear",
                    mapObject: "account",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 8,
                    labelname: "Industry",
                    name: "Industry",
                    code: "industry",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "industryName",
                    mapObject: "industry",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 9,
                    labelname: "Account Email",
                    name: "Account Email",
                    code: "account email",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: true,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: null,
                    mapObject: null,
                    isColumnSetting: false,
                    value: null,
                    displayOrder: 0,
                    fieldTypes: {
                        fields: [
                            {
                                id: 1,
                                labelname: "Account Email",
                                name: "Account Email",
                                code: "work",
                                isrequired: false,
                                ischecked: true,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "work",
                                mapObject: "accountEmail",
                                isColumnSetting: false,
                                value: null,
                            },
                        ],
                        systemGenerated: true,
                        isDisplay: false,
                    },
                },
                {
                    id: 10,
                    labelname: "Account Phone",
                    name: "Account Phone",
                    code: "account phone",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: true,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: null,
                    mapObject: null,
                    isColumnSetting: false,
                    value: null,
                    displayOrder: 0,
                    fieldTypes: {
                        fields: [
                            {
                                id: 1,
                                labelname: "Account Phone",
                                name: "Account Phone",
                                code: "workphone",
                                isrequired: false,
                                ischecked: true,
                                isShowInSetting: true,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "workphone",
                                mapObject: "accountPhone",
                                isColumnSetting: false,
                                value: null,
                            },
                        ],
                        systemGenerated: true,
                        isDisplay: false,
                    },
                },
                {
                    id: 11,
                    labelname: "Account Social",
                    name: "Account Social",
                    code: "account social",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: true,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: null,
                    mapObject: null,
                    isColumnSetting: false,
                    value: null,
                    displayOrder: 0,
                    fieldTypes: {
                        fields: [
                            {
                                id: 1,
                                labelname: "Website",
                                name: "Website",
                                code: "website",
                                isrequired: false,
                                ischecked: true,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "website",
                                mapObject: "accountSocial",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                            {
                                id: 2,
                                labelname: "Twitter",
                                name: "Twitter",
                                code: "twitter",
                                isrequired: false,
                                ischecked: false,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "twitter",
                                mapObject: "accountSocial",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                            {
                                id: 3,
                                labelname: "Facebook",
                                name: "Facebook",
                                code: "facebook",
                                isrequired: false,
                                ischecked: false,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "facebook",
                                mapObject: "accountSocial",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                            {
                                id: 4,
                                labelname: "Linkedin",
                                name: "Linkedin",
                                code: "linkedin",
                                isrequired: false,
                                ischecked: false,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "linkedin",
                                mapObject: "accountSocial",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                            {
                                id: 5,
                                labelname: "Instagram",
                                name: "Instagram",
                                code: "instagram",
                                isrequired: false,
                                ischecked: false,
                                isShowInSetting: false,
                                width: "12",
                                movable: true,
                                showForDrag: true,
                                templateId: 1,
                                sectionId: 1,
                                custom: false,
                                formControlId: 8,
                                formControl: "inputbox",
                                PickListValues: null,
                                field: "instagram",
                                mapObject: "accountSocial",
                                isColumnSetting: false,
                                value: null,
                                displayOrder: 0,
                            },
                        ],
                        systemGenerated: true,
                        isDisplay: false,
                    },
                },
                {
                    id: 12,
                    labelname: "SIC Code",
                    name: "SIC Code",
                    code: "sic",
                    isrequired: false,
                    ischecked: false,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "sicCode",
                    mapObject: "account",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 13,
                    labelname: "NAICS Code",
                    name: "NAICS Code",
                    code: "naics",
                    isrequired: false,
                    ischecked: false,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "naicsCode",
                    mapObject: "account",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 14,
                    labelname: "Account Source",
                    name: "Account Source",
                    code: "account source",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "sourceName",
                    mapObject: "source",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 15,
                    labelname: "Rating",
                    name: "Rating",
                    code: "rating",
                    isrequired: false,
                    ischecked: false,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "ratingName",
                    mapObject: null,
                    isColumnSetting: false,
                    value: null,
                    displayOrder: 0,
                },
                {
                    id: 16,
                    labelname: "Notes",
                    name: "Notes",
                    code: "notes",
                    isrequired: false,
                    ischecked: false,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "description",
                    mapObject: "account",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
            ],
            systemGenerated: true,
            isDisplay: true,
            displayOrder: 2,
        },
        {
            id: 4,
            name: "Address Details",
            fields: [
                {
                    id: 1,
                    labelname: "Street Address 1",
                    name: "Street Address 1",
                    code: "address 1",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "12",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "streetAddress1",
                    mapObject: "accountAddresses",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 2,
                    labelname: "Street Address 2",
                    name: "Street Address 2",
                    code: "address 2",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: false,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "streetAddress2",
                    mapObject: "accountAddresses",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 3,
                    labelname: "Country",
                    name: "Country",
                    code: "country",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "country",
                    mapObject: "accountAddresses",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 4,
                    labelname: "State",
                    name: "State",
                    code: "city",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: true,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "state",
                    mapObject: "accountAddresses",
                    isColumnSetting: true,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 5,
                    labelname: "City",
                    name: "City",
                    code: "city",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "city",
                    mapObject: "accountAddresses",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 6,
                    labelname: "Zip/Postal Code",
                    name: "Zip/Postal Code",
                    code: "zip code",
                    isrequired: false,
                    ischecked: true,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 8,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "zipcode",
                    mapObject: "accountAddresses",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 7,
                    labelname: "Attn.",
                    name: "Attn.",
                    code: "attn",
                    isrequired: false,
                    ischecked: false,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 1,
                    formControl: "dropdownlist",
                    PickListValues: null,
                    field: "attn",
                    mapObject: "accountAddresses",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
                {
                    id: 8,
                    labelname: "Address",
                    name: "Address",
                    code: "address",
                    isrequired: false,
                    ischecked: false,
                    isShowInSetting: false,
                    width: "6",
                    movable: true,
                    showForDrag: true,
                    templateId: 1,
                    sectionId: 1,
                    custom: false,
                    formControlId: 6,
                    formControl: "inputbox",
                    PickListValues: null,
                    field: "address",
                    mapObject: "accountAddresses",
                    isColumnSetting: false,
                    value: "",
                    displayOrder: 0,
                },
            ],
            systemGenerated: true,
            isDisplay: false,
            displayOrder: 3,
        },
    ],
};
